import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, DateInput, ReferenceInput, required, Title} from 'react-admin';
import {PaymentMethodInput, ReportForm, schoolYears, showErrorNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';
import {downloadFilePost} from "../../components/FileDownload";
import axiosInstance from "../../api/axios";
import CheckboxTreeInput from "../../components/CheckboxTreeInput";
import {FormControlLabel} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";

class HsDaDongTienTheoDanhMuc extends React.Component {
    state = {
        products: [],
        changeSchoolYear: false,
        payload: {
            fromDate: moment().format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            productIds: [],
            paymentMethod: '',
            unitIds: [],
            schoolYearId: schoolYears[0].id,
        },
        showUnusedProducts: false,
    };

    componentDidMount() {
        this.getProducts()
            .then(data => this.setState({products: data}))
    }

    getProducts = async () => {
        const url = `/api/billProducts?page=0&size=9999`
        const res = await axiosInstance.get(url)
        return res?.data?.content?.map(item => ({value: item.id, label: `${item.id} - ${item.name}`, name: item.name, enable: item.enable})) || []
    }

    excelReport = () => {
        const {payload} = this.state
        if (!payload.productIds || payload.productIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách phí")
            return;
        }
        if (!payload.unitIds || payload.unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách lớp")
            return;
        }

        const productNames = this.state.products.filter(item => payload.productIds.includes(item.value.toString())).map(item => item.name)
        const data = {
            fromDate: payload.fromDate,
            toDate: payload.toDate,
            paymentMethod: payload.paymentMethod,
            unitIds: payload.unitIds,
            schoolYearId: payload.schoolYearId,
            productNames
        }
        downloadFilePost(`${env.reportURL}/reports/hsDaDongTienTheoDanhMuc`, 'bang_ke_danh_muc_theo_hs.xlsx', data)
    };

    validate = (values) => {
        const errors = {};
        const {fromDate, toDate, productIds, paymentMethod} = values
        // Validate
        if (fromDate && toDate && (fromDate > toDate)) {
            errors.toDate = 'Thời gian không hợp lệ'
        }

        if (!productIds || productIds.length === 0) {
            errors.products = 'Vui lòng chọn danh mục phí'
        }
        if (this.state.changeSchoolYear) {
            this.setState({
                changeSchoolYear: false,
                payload: {
                    ...values,
                    unitIds: []
                }
            })
        } else {
            this.setState({payload: {...values}})
        }
        return errors;
    };

    onSchoolYearChanged(e, value) {
        const {payload} = this.state
        this.setState({
            payload: {
                ...payload,
                schoolYearId: value
            },
            changeSchoolYear: true
        });
    }

    render() {
        const nodes = this.state.products.filter(item => this.state.showUnusedProducts || item.enable)
        return (
            <Card>
                <Title title="resources.hsDaDongTienTheoDanhMuc.name"/>
                <CardContent>
                    <div>Báo cáo danh sách học sinh đã đóng tiền theo trong khoảng thời gian thanh toán và danh mục phí
                        được chọn
                    </div>
                    <p style={{color: 'red'}}><i>Lưu ý: *Dữ liệu học sinh theo danh sách lớp hiện tại</i></p>
                    <ReportForm params={this.state.payload}
                                validate={this.validate}
                                excelReport={this.excelReport}
                                isLoading={this.state.isLoading}
                    >
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.fromDate" source="fromDate"
                                           validate={required()} {...this.props} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.toDate" source="toDate"
                                           validate={required()} {...this.props} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <PaymentMethodInput source="paymentMethod"/>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControlLabel label='Hiện các mục không sử dụng'
                                                  style={{pointerEvents: "none"}}
                                                  control={<Switch checked={this.state.showUnusedProducts}
                                                                   style={{pointerEvents: "auto"}}
                                                                   onChange={() => this.setState({showUnusedProducts: !this.state.showUnusedProducts})}/>}
                                />
                                <div />
                                <CheckboxTreeInput label='Danh sách phí *'
                                                   source='productIds'
                                                   nodes={nodes}
                                                   showNodeIcon={false}/>
                                {!this.state.showUnusedProducts && <div style={{padding: 8, color: "#999", fontStyle: "italic",}}>
                                    ({this.state.products.length - nodes.length} mục không sử dụng bị ẩn)
                                </div>}
                            </Grid>

                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <ReferenceInput source="schoolYearId"
                                                reference="schoolYears"
                                                label="resources.schoolYears.name"
                                                perPage={50}
                                                validate={required()}
                                                onChange={(e, value) => this.onSchoolYearChanged(e, value)}
                                                {...this.props} >
                                    <AutocompleteInput source="name"/>
                                </ReferenceInput>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>Danh sách lớp *</label>
                                <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                    <ReferenceInput source="unitIds"
                                                    reference="units"
                                                    perPage={999}
                                                    filter={{
                                                        clazzWithParents: true,
                                                        schoolYear: this.state.payload.schoolYearId
                                                    }}
                                                    {...this.props} >
                                        <TreeCheckboxInput labelRender={item => `${item.id} - ${item.name}`} optionValue="id" optionText="name" expandTopLevel={true} />
                                    </ReferenceInput>
                                </div>
                            </Grid>
                        </Grid>
                    </ReportForm>
                </CardContent>
            </Card>
        )
    }
}

export default HsDaDongTienTheoDanhMuc;

